
<template>
  <div v-if="payload.iframe" class="iframe-wrapper">
    <div v-html="payload.iframe"></div>
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      default: () => {}
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.iframe-wrapper {
  div {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    & /deep/ iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      border: 0;
    }
  }
}
</style>